<template>
  <v-app>
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="7" class="main-part d-none d-md-none d-lg-flex">
          <div class="d-flex">
            <v-img src="@/assets/logo-projeto.png" contain></v-img>
          </div>
        </v-col>
        <v-col cols="12" lg="5" class="login-part d-flex align-center justify-center">
          <v-row no-gutters class="align-start">
            <v-col cols="12" class="login-part d-flex align-center justify-center flex-column">
              <div class="login-wrapper pt-16 pt-sm-0">
                    <v-form>
                      <v-container>
                        <v-row class="flex-column">
                          <v-col>
                            <p class="login-slogan text-center font-weight-medium my-10">Solicitar nova Senha</p>
                          </v-col>
                          <v-form
                            ref="log"
                            v-model="valid"
                            lazy-validation
                          >
                            <v-col>
                              <v-text-field
                                light
                                id="email"
                                ref="email"
                                v-model="email"
                                :rules="emailRules"
                                single-line
                                label="E-mail"
                                required
                              ></v-text-field>
                            </v-col>
                            <v-col class="d-flex justify-space-between">
                              <v-btn
                                class="text-capitalize"
                                large
                                block
                                :loading="isFetching"
                                color="primary"
                                @click="submit">
                                Solicitar nova Senha
                              </v-btn>
                            </v-col>
                          </v-form>
                        </v-row>
                      </v-container>
                    </v-form>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-center">
              <v-footer v-if="false">
                <div class="primary--text">© 2014-2020 <a href="https://flatlogic.com/" class="text-decoration-none">Flatlogic</a>, LLC. All rights reserved.</div>
              </v-footer>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      top
      v-model="alert"
      color="error">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="alert = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Login',
  data() {
    return {
      valid: true,
      loginTabs: '',
      email: '',
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+/.test(v) || 'E-mail deve ser válido',
        v => v.toLowerCase() === this.email
      ],
      alert: false,
      message: ''
    }
  },
  computed: {
    ...mapState('auth', {
      isFetching: state => state.isFetching,
    }),
  },
  methods: {
    submit() {
      const email = this.email
      this.$store.dispatch("auth/recuperarSenha", email)
      .then(() => {
        const payload = {'emailMensagem': email}
        this.$router.push({name: 'MensagemRecuperaSenha', params: payload});
      });
    },
  },
  watch: {
    errorMessage() {
      this.message = this.errorMessage;
      this.alert = true;
    },
    regErrorMessage() {
      this.message = this.regErrorMessage;
      this.alert = true;
    }
  },

  created() {
  },
}

</script>

<style src="./RecuperarSenha.scss" lang="scss"/>
